import Dialog from "rc-dialog";
import {useTranslation} from "react-i18next";
import {StyledRadioPlayer} from "./styledRadioToggler";
import {useEffect} from "react";

const RadioTogglerModal = ({isVisible, setIsVisible, game, setIsPlay}) => {
    const {t} = useTranslation('siteOptions');

    useEffect(() => {
        const handleMessage = (event) => {
            if (event.data.type === 'radioPlayerState') {
                setIsPlay(event.data.state === "play");
            }
        };

        window.addEventListener('message', handleMessage);

        return () => {
            window.removeEventListener('message', handleMessage);
        };
    }, []);

    useEffect(() => {
        if (isVisible) {
            window.history.pushState({modal: true}, '');

            const handlePopState = () => {
                setIsVisible(false);
            };

            window.addEventListener('popstate', handlePopState);
            return () => window.removeEventListener('popstate', handlePopState);
        }
    }, [isVisible, setIsVisible]);

    return (
        <Dialog
            visible={isVisible}
            wrapClassName={`default-modal-wrapper ${game}`}
            onClose={() => setIsVisible(false)}
            animation="zoom"
            maskAnimation="fade"
            title={t("radioTitle")}
            forceRender={false}
            className="default-modal radio"
        >
            <StyledRadioPlayer>
                <iframe src={process.env.REACT_APP_RADIO_URL}/>
            </StyledRadioPlayer>
        </Dialog>
    );
};

export default RadioTogglerModal;